import { queryClient } from "../queryClient";

export const userDisplayKey = (userId) => ["userDisplay", userId];

export function get(userId) {
  if (!userId) return null;
  return queryClient.getQueryData(userDisplayKey(userId)) ?? null;
}

export function set(userId, value) {
  if (!userId) return;
  queryClient.setQueryData(userDisplayKey(userId), value);
}

export function getDisplayName(userId) {
  const v = get(userId);
  if (v == null) return null;
  return typeof v === "string" ? v : (v.name ?? null);
}

export function getDisplayPhoto(userId) {
  const v = get(userId);
  if (v == null || typeof v === "string") return null;
  return v.photo ?? null;
}
